<template>
  <div>
      <div class="nav" :class="{notTouchingSideNav: !touchingSideNav}"
           :style="{webkitTransform: 'translateX(' + translateX +')'}"
           @transitionend="sendView">
        <div class="header">
          <h1>{{calName}}</h1>
         <!--  <h3 class="sub-title">{{calName}}</h3> -->
        </div>
        <div class="nav-menu">
          <ul class="nav-menu__list">
            <li class="nav-title">
              {{ $t('vue.public.app.sidenav.changeview') }}
            </li>
            <v-touch @tap="setView(1)" class="list-item">
              <li>{{ $t('vue.public.app.sidenav.showday')}}</li>
            </v-touch>
            <v-touch @tap="setView(3)" class="list-item">
              <li>{{ $t('vue.public.app.sidenav.showweek')}}</li>
            </v-touch>
            <v-touch @tap="setView(2)" class="list-item">
              <li>{{ $t('vue.public.app.sidenav.showweekplan')}}</li>
            </v-touch>
            <div class="divider"></div>
            <li class="nav-title">
              {{ $t('repitition.chooselanguage')}}
            </li>
            <div class="list-item">
              <set-locale
                @locale="emitLocale">
              </set-locale>
            </div>
          </ul>
        </div>
      </div>
    <v-touch
      v-if="menu"
      @panstart="onPanStart"
      @panend="onPanEnd"
      @pan="moveMenu"
      @tap="$emit('close')">
      <div class="drag-target"></div>
    </v-touch>
    <transition name="opacity">
      <div class="nav-overlay" v-if="menu"></div>
    </transition>
  </div>
</template>

<script>
  import setLocale from '../../Locale/SetLocale.vue'
  export default {
    components: {setLocale},
    props: {
      menu: {
        default: false
      },
      schoolName: {},
      calName: {},
      chosenView: {
        default: 1
      }
    },
    data () {
      return {
        view: this.chosenView,
        startX: 0,
        currentX: 0,
        translate: 0,
        translateX: -105 + '%',
        touchingSideNav: false
      }
    },
    watch: {
      chosenView () {
        this.view = this.chosenView
      },
      menu (val) {
        if (val) {
          this.translateX = 0 + '%'
        } else {
          this.translateX = -105 + '%'
        }
      }
    },
    methods: {
      onPanStart (e) {
        this.touchingSideNav = true
        this.startX = e.srcEvent.pageX
        window.requestAnimationFrame(this.update)
      },
      onPanEnd (e) {
        this.touchingSideNav = false
        if (this.translate < 0) {
          this.$emit('close')
        }
      },
      moveMenu (e) {
        if (!this.touchingSideNav) {
          return
        }
        this.currentX = e.srcEvent.pageX
        this.translate = Math.min(0, this.currentX - this.startX)
      },
      update () {
        if (!this.touchingSideNav) {
          return
        }
        window.requestAnimationFrame(this.update)
        this.translateX = Math.min(0, this.currentX - this.startX) + 'px'
      },
      setView (num) {
        this.$emit('close')
        this.view = num
      },
      sendView () {
        // Wait for animation to end before updating view in parent
        this.$emit('afterLeave', this.view)
      },
      emitLocale (val) {
        this.$emit('locale', val)
      }
    }
  }
</script>

<style scoped>
  @import '../../../assets/css/variables.css';

  .nav {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 10000;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    width: 80%;
    will-change: transform;
    transition: none;
  }

  .nav.notTouchingSideNav {
    transition: transform 0.33s cubic-bezier(0, 0, 0.3, 1);
  }

  .header {
    padding: 10px 32px;
    background: var(--blue);
  }

  .sub-title {
    color: white;
  }

  .nav-menu__list > .list-item {
    font-size: 14px;
    padding: 10px 32px;
    font-weight: bold;
  }

  .nav-overlay {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 5000;
    background-color: rgba(0, 0, 0, 0.5);
    will-change: opacity;
    transition: opacity 0.3s cubic-bezier(0, 0, 0.3, 1);
  }

  .nav-title {
    font-weight: 500;
    padding: 10px 32px;
    cursor: initial;
    pointer-events: none;
    color: rgba(0, 0, 0, 0.54);
    font-size: 14px;
    line-height: 38px;
  }

  .divider {
    height: 1px;
    overflow: hidden;
    background-color: #e0e0e0;
  }

  .nav-pan {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 22%;
    z-index: 100000;
  }

  .drag-target {
    background: none;
    height: 100%;
    width: 22%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 20000;
  }

</style>



// WEBPACK FOOTER //
// SideNav.vue?73074e46